/* unplugin-vue-components disabled */import { render } from "./VersionList.vue?vue&type=template&id=b69c138c&scoped=true"
import script from "./VersionList.vue?vue&type=script&lang=js"
export * from "./VersionList.vue?vue&type=script&lang=js"

import "./VersionList.vue?vue&type=style&index=0&id=b69c138c&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\Juanfu\\CBK定制版\\hcontrol_download\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b69c138c"]])

export default __exports__